import createIcon from '../../createIcon';

/**
 * @component @name AlignVerticalBottom
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMjJIMlYyMEgyMlYyMlpNMTAgMkg3VjE4SDEwVjJaTTE3IDhIMTRWMThIMTdWOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AlignVerticalBottom = createIcon('AlignVerticalBottom', [
  ['path', { d: 'M22 22H2V20H22V22ZM10 2H7V18H10V2ZM17 8H14V18H17V8Z', key: 'nk3uj5' }],
]);

export default AlignVerticalBottom;
